module.exports = __webpack_public_path__ + "static/media/48.4bb17c4.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/48.wav
// module id = llgW
// module chunks = 0